<template lang="pug">
    .container
        section(v-if="headerSections.length" v-for="(section, index) in headerSections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            Banners(v-if="section.key === 'banner'" :section="section")
            PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
            Contact(v-if="section.key === 'contact'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
        .columns(:class="{hasinformation: additionalSections.length}")
            .column.left
                slot(name="header")
                main.contentpage
                    .section(v-if="mainSections.length" v-for="(section, index) in mainSections" :key="section.id" :class="section.key")
                        Heading(v-if="section.key === 'heading'" :section="section")
                        Post(v-if="section.key === 'post'" :section="section")
                        Banners(v-if="section.key === 'banner'" :section="section")
                        PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
                        Contact(v-if="section.key === 'contact'" :section="section")
                        ImageSection(v-if="section.key === 'image'" :section="section")
            .column.right.is-one-third(v-if="additionalSections.length")
                .card
                    .card-header.is-offset-1
                        h3 INFOS
                    .section.card-content(v-for="(section, index) in additionalSections" :key="section.id" :class="section.key")
                        ImageSection(v-if="section.key === 'image'" :section="section")
                        Heading(v-if="section.key === 'heading'" :section="section")
                        Post(v-if="section.key === 'post'" :section="section")
                    slot(name="footer")
        section(v-if="mainFullSections.length" v-for="(section, index) in mainFullSections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            Banners(v-if="section.key === 'banner'" :section="section")
            PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
            Contact(v-if="section.key === 'contact'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'
import Slider from '@/components/Slider'
import PhotoAlbum from '@/components/PhotoAlbum'
// import CategoryPosts from '@/components/CategoryPosts'
// import SocialWall from '@/components/SocialWall'
import Banners from '@/components/Banners'

export default {
    name: 'ContentPage',
    components: {
        Heading,
        ImageSection,
        Post,
        Slider,
        PhotoAlbum,
        // CategoryPosts,
        // SocialWall,
        Banners,
    },
    computed: {
        headerSections() {
            return this.sections.filter(section => {
                return section.area === 'header'&& 
                (section.key === 'heading' || section.key === 'post' || section.key === 'image' || section.key === 'photoalbum' || section.key === 'banners' || section.key === 'contact')
            })
        },
        mainSections() {
            return this.sections.filter(section => {
                return section.area === 'main'&& 
                (section.key === 'heading' || section.key === 'post' || section.key === 'image' || section.key === 'photoalbum' || section.key === 'banners' || section.key === 'contact') 
                || section.area === 'left'&& 
                (section.key === 'heading' || section.key === 'post' || section.key === 'image' || section.key === 'photoalbum' || section.key === 'banners' || section.key === 'contact')
            })
        },
        mainFullSections() {
            return this.sections.filter(section => {
                return section.area === 'main-full-width'&& 
                (section.key === 'heading' || section.key === 'post' || section.key === 'image' || section.key === 'photoalbum' || section.key === 'banners' || section.key === 'contact')
            })
        },
        additionalSections() {
            return this.sections.filter(section => {
                return section.area === 'right' && (section.key === 'image' || section.key === 'post'|| section.key === 'heading') || section.area === 'sidebar' && (section.key === 'image' || section.key === 'post'|| section.key === 'heading')
            })
        },
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'image'
                    || section.key === 'post'
                    || section.key === 'slider'
                    || section.key === 'photoalbum'
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
        })
    }
}

</script>

<style lang="sass" scoped>
    .hasinformation
        padding: 0 3.5em
    .card
        margin-top: 4.5rem
        .card-header
            padding: 2em 2.5em
            background-color: #565656
            color: #fff
            h3
                font-size: 20px
                font-weight: bold
        .card-content
            background-color: #d8d8d8
            padding-left: 0
            padding-right: 0
    .contentpage
        & > .section
            padding-bottom: 0
            &:first-child
                padding-top: 4.5rem
            &:last-child
                padding-bottom: 4.5rem
            &.category-page-teaser
                display: none
        .section.slider,
        .section.banners
            padding: 0
        .section.heading
            text-transform: initial
</style>
